import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { HrEmployeeStatus } from "@/types/hr/Hr";
import { hrEmployeeStatusLabel } from "@/utils/hrEmployeeStatus";

export default /*#__PURE__*/_defineComponent({
  props: {
    status: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(
      __props.status === 'ACTIVE'
        ? 'tag tag--success'
        : __props.status === 'DISMISSED'
        ? 'tag tag--error'
        : `hr-status hr-status--${__props.status.toLowerCase()}`
    )
  }, _toDisplayString(_unref(hrEmployeeStatusLabel)(__props.status)), 3))
}
}

})